document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto projektu (detail-2)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('[data-detail-project-gallery]');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 2,
            spaceBetween: 20,
            initialSlide: 0,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 2,
                },
                1600: {
                    slidesPerView: 3,
                },
                3050: {
                    slidesPerView: 4,
                }
            }
        });
    }());
});